

import { useEffect, useState } from "react";
import { useBlogStore } from "../store/blog-store.js";
import { useConfigStore } from "../store/config-store.js";
import { fetchConfigClient } from "../lib/config.js";

export const useBlogInitializer = () => {
  const setBlogs = useBlogStore((s) => s.setBlogs);
  const setConfig = useConfigStore((s) => s.setConfig);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const initializeBlogData = async () => {
      try {
        console.log("Starting blog initialization...");
        const config = await fetchConfigClient();

        if (config) {
          console.log("Config loaded successfully:", config);
          setConfig(config);

          // Extract blogs from blogsection
          if (config.blogsection && Array.isArray(config.blogsection)) {
            console.log(
              "Setting blogs from blogsection:",
              config.blogsection
            );
            setBlogs(config.blogsection);
          } else {
            console.warn("No blogsection found in config");
            setError("No blog data found in configuration");
          }
        } else {
          console.error("Failed to fetch config");
          setError("Failed to fetch blog configuration");
        }
      } catch (err) {
        console.error("Error during blog initialization:", err);
        setError(err instanceof Error ? err.message : "Unknown error occurred");
      } finally {
        setIsLoading(false);
      }
    };

    initializeBlogData();
  }, [setBlogs, setConfig]);

  return { isLoading, error };
};
